import { render } from "./WohnungStep11b.vue?vue&type=template&id=5270360d"
import script from "./WohnungStep11b.vue?vue&type=script&lang=js"
export * from "./WohnungStep11b.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__